import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { IAfterGuiAttachedParams, ICellRendererParams } from 'ag-grid-community';
import * as _ from 'lodash-es';

@Component({
  selector: 'pps-position-checkbox',
  template: `
    <input type="checkbox" (click)="checkedHandler($event)" [checked]="checked" />
  `,
  styles: [
  ],
})
export class PositionCheckboxComponent implements AgRendererComponent {
  params: any;
  checked: boolean;
  constructor() { }

  refresh(params: any): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    
    if (this.params.column.colId === "salary-employee"){
      this.checked = this.params.data.salaryEmployee;
    }

    if (this.params.column.colId === "lead-head"){
      this.checked = this.params.data.leadHead;
    }

    if (this.params.column.colId === "logRnR"){
      this.checked = this.params.data.logRnR;
    }
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error("Method not implemented.");
  }

  checkedHandler(event) {
    let checked = event.target.checked;
    if (this.params.column.colId === "salary-employee"){
      this.params.data.salaryEmployee = checked;
    }

    if (this.params.column.colId === "lead-head"){
      this.params.data.leadHead = checked;
    }

    if (this.params.column.colId === "logRnR"){
      this.params.data.logRnR = checked;
    }

    this.params.context.componentParent.updatePosition(this.params.data);
  }  
}